import { Injectable } from '@angular/core';
import {ConfigurationDataService} from '../configuration-data.service';
import {SharedDataService} from '../shared-data.service';
import { HttpClient, HttpHeaders } from '@angular/common/http';

import {Location, LocationGeneratorData} from './location';

@Injectable()
export class LocationService {

  headers = new HttpHeaders({
      'Content-Type': 'application/json'
  });

  constructor(public http: HttpClient, private config : ConfigurationDataService, private shared: SharedDataService) {
  }

  /**
   * List all locations which belong to loggedin user.
   */
  public list() {
    console.log(JSON.stringify(this.shared.getTokenAuthData()));
    return this.http.post(this.config.locationURL+"list", JSON.stringify(this.shared.getTokenAuthData()), {headers: this.headers});
  }

  public save(location : Location) {
    console.log('Push location to insert method of service.');
    location.credentials = this.shared.getTokenAuthData();
    console.log(JSON.stringify(location));
    return this.http.post(this.config.locationURL+"new", JSON.stringify(location), {headers: this.headers});
  }

  public update(location : Location) {
    console.log('Push location to update method of service.');
    location.credentials = this.shared.getTokenAuthData();
    console.log(JSON.stringify(location));
    return this.http.put(this.config.locationURL+"id/"+location.id, JSON.stringify(location), {headers: this.headers});
  }

  public qryLocation(id : number) {
    return this.http.post(this.config.locationURL+"id/"+id, 
    JSON.stringify(this.shared.getTokenAuthData()), {headers: this.headers});
  }

  public delete(id : number) {
    console.log('Delete location '+ id);
    return this.http.post(this.config.locationURL+"del/"+id, 
    JSON.stringify(this.shared.getTokenAuthData()), {headers: this.headers});
  }

  public cntLocations(areaid : number) {
    console.log('Get count of locations in area '+ areaid);
    return this.http.post(this.config.locationURL+"area/"+areaid+"/cnt", 
    JSON.stringify(this.shared.getTokenAuthData()), {headers: this.headers});
  }

  public listLocationsInArea(areaid : number) {
    console.log('Get list of locations in area '+ areaid);
    return this.http.post(this.config.locationURL+"area/"+areaid+"/list", 
    JSON.stringify(this.shared.getTokenAuthData()), {headers: this.headers});
  }

  public generateSetOfLocations(pLocationSet : LocationGeneratorData) {
    pLocationSet.credentials = this.shared.getTokenAuthData();
    pLocationSet.userid = pLocationSet.credentials.userId;

    console.log('Generate set of locations: '+ JSON.stringify(pLocationSet));
    return this.http.post(this.config.locationURL+"generate", 
    JSON.stringify(pLocationSet), {headers: this.headers});
  }
}



// WEBPACK FOOTER //
// /home/pneuser/workspace/pepelogistic/pepeLogisticControl/src/app/location/location.service.ts